import React, {useEffect} from 'react'
import {Router, Switch} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'
import {history} from '../helpers/history'
import Public from './Routes/Public'
import Private from './Routes/Private'
import PrivateEmployer from './Routes/PrivateEmployer'
import Home from '../pages/Home'
import Login from '../pages/Login'
import Register from '../pages/Register'
import ForgotPassword from '../pages/ForgotPassword'
import OAuth from '../pages/OAuth'
import NewPassword from '../pages/NewPassword'
import CompanyAbout from '../pages/CompanyAbout'
import SelectedCompany from '../pages/SelectedCompany'
import Notification from '../componets/Legacy/Notification'
import {actions as notificationActions} from '../redux/ducks/notification'
import routes from '../config/routes'
import Test from '../pages/Test'
import PayrollDashboard from "../pages/PayrollDashboard";
import DashboardWelcome from "../components/Organisms/Sections/DashboardWelcome";
import Dashboard from "../pages/Dashboard";
import MainNavigation from "../components/Organisms/MainNavigation";
import Employees from '../pages/Employees'
import Company from '../pages/Company'
import Profile from '../pages/Profile'

const App = () => {
  const dispatch = useDispatch()
  const notification = useSelector(store => store.notificationReducer)

  const handleClose = () => dispatch(notificationActions.clear())

  useEffect(() => {
    document.body.classList.add('loggued')

    return () => document.body.classList.remove('loggued')
  }, [])

  return (
    <>
      <Notification
        message={notification.message}
        severity={notification.severity}
        onClose={handleClose}
      />
      {/**/}

      <Router history={history}>
        <MainNavigation />
        <Switch>
          <main className='main'>
            <Public path={routes.dashboard}
              exact
              component={Dashboard}/>
            <Public path={routes.employees}
              exact
              component={Employees}/>
            <Public path={routes.payroll}
              exact
              component={PayrollDashboard}/>
            <Public path={routes.company}
              exact
              component={Company}/>
            <Public path={routes.profile}
              exact
              component={Profile}/>
          </main>
        </Switch>
      </Router>
    </>
  )
}

export default App
